import { render, staticRenderFns } from "./TeacherProgressWidget.vue?vue&type=template&id=15772b2c"
import script from "./TeacherProgressWidget.vue?vue&type=script&lang=js"
export * from "./TeacherProgressWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports